import { Component, OnInit } from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {UserService} from '../../shared/api/resources/user/user.service';
import {AgentService} from '../../shared/api/resources/agent/agent.service';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit {
  url: string;
  navItems = [
    // {
    //   label: 'Overview',
    //   href: '/',
    // },
    {
      label: 'My Partners',
      href: '/experiences',
    },
    {
      label: 'Explore',
      href: '/explore',
    },
    {
      label: 'Bookings',
      href: '/bookings',
    },
    // {
    //   label: 'Reports',
    //   href: '/reports',
    // },
  ];

  constructor(private _router: Router, private _userService: UserService, private _agentService: AgentService) {
    this.url = this._router.url;
  }

  ngOnInit() {
    this._router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.url = val.url;
      }
    });
    if (this._userService.userHasAccess('manage')) {
      this.navItems.push({
        label: 'Manage',
        href: '/manage'
      });
    }
  }

  get userHasPartners(): Boolean {
    return this._agentService.suppliers && this._agentService.suppliers.length > 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/header/navigation/navigation.component.ts